import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { APP_ROUTES } from '../../utils/constants';
import './ModaleConnexion.scss';

function ModaleConnexion({ onClose }) {
  const [isOpen, setIsOpen] = useState(true);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => onClose(), 280);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.error || 'Mot de passe invalide.');
        setIsSubmitting(false);
        return;
      }
      navigate(APP_ROUTES.ADMIN_PANEL);
      handleClose();
    } catch {
      setError('Connexion impossible. Réessayez.');
      setIsSubmitting(false);
    }
  };

  return createPortal(
    <div className="modaleConnexion">
      <div className={`modaleConnexion__overlay ${isOpen ? '' : 'closing'}`} onClick={handleClose}></div>
      <div className={`modaleConnexion__card ${isOpen ? '' : 'closing'}`}>
        <div className="modaleConnexion__top-bar"></div>

        <div className="modaleConnexion__header">
          <span className="modaleConnexion__label">Espace gérantes</span>
          <button onClick={handleClose} className="modaleConnexion__close" aria-label="Fermer">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <form className="modaleConnexion__body" onSubmit={handleSubmit}>
          <label className="modaleConnexion__field">
            <span>Mot de passe</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              autoFocus
              required
            />
          </label>

          {error && <p className="modaleConnexion__error">{error}</p>}

          <button type="submit" className="modaleConnexion__submit" disabled={isSubmitting}>
            {isSubmitting ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
}

export default ModaleConnexion;
